import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ERatioWidgetDisplayType } from 'scw-digital-boards-widgets';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../../../../../shared/components/mat-dropdown/scw-mat-dropdown.interface';

@Component({
  imports: [MatDropdown],
  selector: 'ratio-widget-display-type-dropdown',
  templateUrl: './ratio-widget-display-type-dropdown.component.html',
})
export class RatioWidgetDisplayTypeDropdownComponent {
  private readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<ERatioWidgetDisplayType>[]>>();
  public readonly isFormSubmitted = input.required<boolean>();

  public readonly dropdownOptions = Object.values(ERatioWidgetDisplayType).map((displayType) => ({
    id: displayType,
    name: this.translate.instant(`widget.ratio.displayType.${displayType}`),
  }));

  public readonly dropdownConfiguration: IDropdownSettings = {
    enableSearchFilter: false,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('page.widgetContent.addEditDialog.ratioWidgetDisplayType'),
  };
}
